import { integrationPlugin } from '@vue-storefront/core';

const moduleOptions = {};

export default integrationPlugin(({ integration }) => {
  integration.configure('xbuy', {
    ...moduleOptions
    // other options
  });
});
